var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundTallkmeLigth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 600,
    viewBox: "0 0 342 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 600,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.974 338C297.974 312.683 290.526 287.935 276.572 266.886C262.618 245.836 242.784 229.43 219.58 219.742C196.375 210.055 170.841 207.521 146.208 212.461C121.575 217.4 98.9479 229.593 81.189 247.495C63.4301 265.398 51.3368 288.206 46.4385 313.037C41.5401 337.867 44.0568 363.604 53.6701 386.993C63.2835 410.381 79.5618 430.371 100.446 444.435C121.331 458.498 145.884 466.003 171 466C205.257 466 231.331 454.247 254.599 433.688C255.199 433.114 255.976 432.764 256.801 432.696C257.625 432.628 258.448 432.847 259.132 433.316L292.005 460.064C292.575 460.461 293.242 460.695 293.934 460.74C294.626 460.785 295.317 460.639 295.933 460.318C296.549 459.998 297.067 459.514 297.431 458.919C297.795 458.325 297.992 457.641 298 456.943C297.987 440.408 297.974 353.99 297.974 338ZM170.433 407.764C152.078 407.561 134.553 400.023 121.707 386.805C108.861 373.588 101.744 355.772 101.92 337.27C101.999 328.557 102.579 272.459 102.579 272.459C102.542 272.061 102.625 271.661 102.817 271.312C103.009 270.962 103.301 270.678 103.654 270.498C104.008 270.317 104.408 270.248 104.801 270.3C105.194 270.351 105.563 270.521 105.86 270.786L123.634 285.554C124.004 285.81 124.45 285.931 124.898 285.897C125.346 285.863 125.769 285.677 126.097 285.368C138.904 274.305 153.147 268.103 171.843 268.249C180.985 268.263 190.033 270.102 198.465 273.66C206.897 277.218 214.547 282.424 220.972 288.979C227.397 295.533 232.471 303.305 235.899 311.847C239.328 320.388 241.044 329.53 240.948 338.744C240.853 347.957 238.947 357.061 235.342 365.528C231.736 373.996 226.503 381.659 219.943 388.076C213.383 394.494 205.627 399.537 197.122 402.917C188.618 406.296 179.534 407.943 170.394 407.764H170.433Z",
    fill: "url(#paint0_linear_2101_542)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2101_542",
    x1: 140.485,
    y1: 160.848,
    x2: 202.383,
    y2: 514.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74CBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#69C5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4AB5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#199CCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0692C8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundTallkmeLigth);
export default __webpack_public_path__ + "static/media/background-tallkme-ligth.d3670d1ff154da9bc53ecb6a98c2ca00.svg";
export { ForwardRef as ReactComponent };